import { createSignal, type JSX } from "solid-js";
import { truncateMiddle } from "../utils/format";

interface CopyTextProps {
  value: string;
  label: string;
  secret?: boolean;
  onError?: () => void;
}

export function CopyText(props: CopyTextProps): JSX.Element {
  const [copied, setCopied] = createSignal(false);

  async function copy(): Promise<void> {
    try {
      await navigator.clipboard.writeText(props.value);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
    } catch {
      props.onError?.();
    }
  }

  return (
    <span class={`copy-text ${props.secret ? "copy-text--secret" : ""}`}>
      <code title={props.secret ? undefined : props.value}>
        {props.secret ? props.value : truncateMiddle(props.value)}
      </code>
      <button
        type="button"
        class="copy-text__button"
        aria-label={`复制${props.label}`}
        data-copied={copied() ? "true" : undefined}
        onClick={() => void copy()}
      >
        复制
      </button>
      <span class="sr-only" role="status">{copied() ? `${props.label} 已复制` : ""}</span>
    </span>
  );
}
